import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_ANALYTIC } from "../../constants";

export const getListPeopleCount = createAsyncThunk(
    "count/page",
    async (param, thunkAPI) => {
      // console.log(param)
      const respone = await fetch(
        `${API_ANALYTIC}/api/cardSensor?siteId=${param.siteId}&analyticId=PPLCNT&waktu=daily`,
        // ?page=${param.page}&size=${param.size}&sort=${param.select},${param.sort}&${param.select}=${param.filter}
        {
          method: "get",
          headers: new Headers({
            Authorization: 'Bearer ' + param.token,
            //    + param.token,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Credentials": "true",
          }),
        }
      );
      if (respone.status === 200) {
        const responeResult = await respone.json();
        // console.log("as")
        return responeResult;
      } else {
        return {
          data: {
            totalElements: 0,
            totalPages: 0,
            last: true,
            size: 0,
            number: 0,
            numberOfElements: 0,
            first: true,
            empty: false,
          },
        };
      }
    }
  );

export const getListPeopleLean = createAsyncThunk(
    "lean/page",
    async (param, thunkAPI) => {
      // console.log(param)
      const respone = await fetch(
        `${API_ANALYTIC}/api/cardSensor?siteId=${param.siteId}&analyticId=PPLLEN`,
        // ?page=${param.page}&size=${param.size}&sort=${param.select},${param.sort}&${param.select}=${param.filter}
        {
          method: "get",
          headers: new Headers({
            Authorization: 'Bearer ' + param.token,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Credentials": "true",
          }),
        }
      );
      if (respone.status === 200) {
        const responeResult = await respone.json();
        // console.log("as")
        return responeResult;
      } else {
        return {
          data: {
            totalElements: 0,
            totalPages: 0,
            last: true,
            size: 0,
            number: 0,
            numberOfElements: 0,
            first: true,
            empty: false,
          },
        };
      }
    }
  );

export const getListPeopleJump = createAsyncThunk(
    "jump/page",
    async (param, thunkAPI) => {
      // console.log(param)
      const respone = await fetch(
        `${API_ANALYTIC}/api/cardSensor?siteId=${param.siteId}&analyticId=PPLJMP`,
        // ?page=${param.page}&size=${param.size}&sort=${param.select},${param.sort}&${param.select}=${param.filter}
        {
          method: "get",
          headers: new Headers({
            Authorization: 'Bearer ' + param.token,
            //    + param.token,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Credentials": "true",
          }),
        }
      );
      if (respone.status === 200) {
        const responeResult = await respone.json();
        // console.log("as")
        return responeResult;
      } else {
        return {
          data: {
            totalElements: 0,
            totalPages: 0,
            last: true,
            size: 0,
            number: 0,
            numberOfElements: 0,
            first: true,
            empty: false,
          },
        };
      }
    }
  );

  export const getListPintuUtara = createAsyncThunk(
    "utara/page",
    async (param, thunkAPI) => {
      // console.log(param)
      const respone = await fetch(
        `${API_ANALYTIC}/api/cardSensor?siteId=${param.siteId}&analyticId=PPLCNT&waktu=daily&locName=Pintu Barat`,
        // ?page=${param.page}&size=${param.size}&sort=${param.select},${param.sort}&${param.select}=${param.filter}
        {
          method: "get",
          headers: new Headers({
            Authorization: 'Bearer ' + param.token,
            //    + param.token,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Credentials": "true",
          }),
        }
      );
      if (respone.status === 200) {
        const responeResult = await respone.json();
        // console.log("as")
        return responeResult;
      } else {
        return {
          data: {
            totalElements: 0,
            totalPages: 0,
            last: true,
            size: 0,
            number: 0,
            numberOfElements: 0,
            first: true,
            empty: false,
          },
        };
      }
    }
  );

  export const getListPintuSelatan = createAsyncThunk(
    "selatan/page",
    async (param, thunkAPI) => {
      // console.log(param)
      const respone = await fetch(
        `${API_ANALYTIC}/api/cardSensor?siteId=${param.siteId}&analyticId=PPLCNT&waktu=daily&locName=Pintu Timur`,
        // ?page=${param.page}&size=${param.size}&sort=${param.select},${param.sort}&${param.select}=${param.filter}
        {
          method: "get",
          headers: new Headers({
            Authorization: 'Bearer ' + param.token,
            //    + param.token,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Credentials": "true",
          }),
        }
      );
      if (respone.status === 200) {
        const responeResult = await respone.json();
        // console.log("as")
        return responeResult;
      } else {
        return {
          data: {
            totalElements: 0,
            totalPages: 0,
            last: true,
            size: 0,
            number: 0,
            numberOfElements: 0,
            first: true,
            empty: false,
          },
        };
      }
    }
  );

  export const getListStatistik = createAsyncThunk(
    "statistik/page",
    async (param, thunkAPI) => {
      console.log(param)
      let filter = `startDate=${param.filter.startDate}&endDate=${param.filter.endDate}`
      const respone = await fetch(
        `${API_ANALYTIC}/api/siteHourly/grafik?${filter}&siteId=${param.siteId}&analyticId=PPLCNT`,
        // ?page=${param.page}&size=${param.size}&sort=${param.select},${param.sort}&${param.select}=${param.filter}
        {
          method: "get",
          headers: new Headers({
            Authorization: 'Bearer ' + param.token,
            //    + param.token,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Credentials": "true",
          }),
        }
      );
      if (respone.status === 200) {
        const responeResult = await respone.json();
        // console.log("as")
        return responeResult;
      } else {
        return {
          data: {
            totalElements: 0,
            totalPages: 0,
            last: true,
            size: 0,
            number: 0,
            numberOfElements: 0,
            first: true,
            empty: false,
          },
        };
      }
    }
  );

  export const getListBar = createAsyncThunk(
    "bar/page",
    async (param, thunkAPI) => {
      // console.log(param)
      let filter = `siteId=${param.siteId}&dates=${param.dates}`
      // const respone = await fetch(`${API_CORRECTIVE}/api/dashboard/mttrFilter?${filter}`, {
      let urlAPI = `${API_ANALYTIC}/api/statistik?analyticId=PPLCNT&${filter}`
      const respone = await fetch(urlAPI, {
      // const respone = await fetch(
      //   `http://202.180.16.237:28080/analytic/api/statistik?siteId=${param.siteId}&analyticId=PPLCNT`,
      //   // ?page=${param.page}&size=${param.size}&sort=${param.select},${param.sort}&${param.select}=${param.filter}
      //   {
          method: "get",
          headers: new Headers({
            Authorization: 'Bearer ' + param.token,
            //    + param.token,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Credentials": "true",
          }),
        }
      );
      if (respone.status === 200) {
        const responeResult = await respone.json();
        // console.log("as")
        return responeResult;
      } else {
        return {
          data: {
            totalElements: 0,
            totalPages: 0,
            last: true,
            size: 0,
            number: 0,
            numberOfElements: 0,
            first: true,
            empty: false,
          },
        };
      }
    }
  );


